import { useQuasar } from 'quasar';
import { ref } from 'vue';

export const enum NotifyType {
  ERROR,
  WARNING,
  SUCCESS,
  INFO,
}

interface UseNotify {
  notify: (msg: string, type: NotifyType, configurableOptions?: Partial<NotifyOption>) => void;
}

interface NotifyOption {
  type: string;
  message: string;
  timeout?: number;
  actions?: NotifyAction[];
  icon?: string;
  color?: string;
}

export interface NotifyAction {
  label: string;
  color?: string;
  icon?: string;
  handler: () => void;
}

const DEFAULT_OPTION: NotifyOption = {
  type: 'info',
  message: '',
  timeout: 2500,
};

export const useNotify: () => UseNotify = () => {
  const $q = useQuasar();

  const notify = (msg: string, type: NotifyType, configurableOptions?: Partial<NotifyOption>): void => {
    const options = ref(DEFAULT_OPTION);
    options.value.message = msg;
    switch (type) {
      case NotifyType.WARNING: {
        options.value.type = 'warning';
        options.value.timeout = 4000;
        break;
      }
      case NotifyType.ERROR: {
        options.value.type = 'negative';
        options.value.timeout = 4000;
        break;
      }
      case NotifyType.INFO: {
        options.value.type = 'info';
        options.value.timeout = 4000;
        break;
      }
      case NotifyType.SUCCESS: {
        options.value.type = 'positive';
        options.value.timeout = 1500;
        break;
      }
      default: {
        options.value.type = 'info';
        options.value.timeout = 2500;
        break;
      }
    }

    options.value = { ...options.value, ...configurableOptions };
    $q.notify(options.value);
  };

  return { notify };
};
